import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import RenderNocFormFields from "./RenderNocFormFields";
import CreateNewNocModal from "../documentNocModals/CreateNewNocModal";
import { currentProcessingNocFileBase } from "../../../../data/userPackage/prepareNoc";
import { FaPlayCircle } from "react-icons/fa";
import { Photo } from "@mui/icons-material";
import { setModalsState } from "../../../../store/actions/uiActions/myPermitsActions";
import { useDispatch } from "react-redux";

const NocSelectedPackage = ({
  currentProcessingFile,
  setCurrentProcessingFile,
  handleDiscardInitNoc,
  setOnBanner,
  // setPaymentModalOpen,
  // setAddPaymentModalOpen,
  cards,
  actionText,
  setActionText,
}) => {
  const extraSmall = useMediaQuery((theme) => theme.breakpoints.down("xsm"));
  const mobileSize = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const [deleteFormModalOpen, setDeleteFormModalOpen] = useState(false);
  const [deleteFormLoading, setDeleteFormLoading] = useState(false);
  const [failedValidatedProceed, setFailedValidatedProceed] = useState(true);
  const [isFormPreview, setIsFormPreview] = useState(false);

  const [selectedContractor, setSelectedContractor] = useState({});
  const [contractors, setContractors] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    const actions = currentProcessingFile?.document?.actions || null;

    if (actions) {
      const notarize = actions?.notarize;
      const record = actions?.record;

      if (notarize && record) {
        setActionText("Notarize & Record");
      } else if (notarize) {
        setActionText("Notarize Only");
      } else if (record) {
        setActionText("Record Only");
      } else {
        setActionText("");
      }
    }
  }, [currentProcessingFile, setActionText]);

  const handleDeleteDocument = async () => {
    try {
      setDeleteFormLoading(true);
      await handleDiscardInitNoc();
      setOnBanner(true);
      setCurrentProcessingFile(currentProcessingNocFileBase);
    } catch (error) {
      console.error("Error deleting document:", error);
    } finally {
      setDeleteFormLoading(false);
    }
  };

  useEffect(() => {
    const { notarize, record } = currentProcessingFile?.document?.actions || {};

    let contractorValid = true;
    let ownerValid = true;
    let emailValid = true;
    let phoneValid = true;

    if (record) {
      const contractor = currentProcessingFile?.contractor;
      const org = contractor?.ORGANIZATION;
      const person = contractor?.PERSON;

      const email = contractor?.email || "";
      const phone = contractor?.phone_number || "";

      contractorValid = !!(
        org?.nameUnparsed?.trim() &&
        person?.first_name?.trim() &&
        person?.last_name?.trim() &&
        // contractor?.address?.trim() &&
        contractor?.email?.trim() &&
        contractor?.phone_number?.trim() &&
        contractor?.licenseNumber?.trim()
      );

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) emailValid = false;
      if (phone.replace(/\D/g, "").length !== 10) phoneValid = false;
    }

    if (record || notarize) {
      const owner = currentProcessingFile?.signer;
      const person = owner?.PERSON;

      const email = owner?.email || "";
      const phone = owner?.phone_number || "";

      const isRecordOnly = record && !notarize;

      ownerValid = !!(
        // org?.nameUnparsed?.trim() &&
        (
          person?.first_name?.trim() &&
          person?.last_name?.trim() &&
          // owner?.address?.trim() &&
          (!isRecordOnly ? owner?.email?.trim() : true) &&
          (!isRecordOnly ? owner?.phone_number?.trim() : true) &&
          // currentProcessingFile?.document_location?.project_address?.trim() &&
          currentProcessingFile?.document_location?.county?.trim()
        )
      );

      if (!isRecordOnly) {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) emailValid = false;
        if (phone.replace(/\D/g, "").length !== 10) phoneValid = false;
      }
    }

    const shouldProceed =
      (record ? contractorValid && ownerValid : ownerValid) &&
      emailValid &&
      phoneValid;
    setFailedValidatedProceed(!shouldProceed);
  }, [
    currentProcessingFile?.signer,
    currentProcessingFile?.contractor,
    currentProcessingFile?.document?.actions?.notarize,
    currentProcessingFile?.document?.actions?.record,
    currentProcessingFile?.document?.actions,
    currentProcessingFile?.document_location?.county,
  ]);

  return (
    <>
      {/* Fixed Header with Stepper */}
      <Box
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          height: mobileSize ? "auto" : "calc(100vh - 250px)",
        }}
      >
        {/* Fixed Header */}
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 2,
            bgcolor: "white",
            py: 2,
            px: mobileSize ? 0 : 2,
            borderBottom: "3px solid #e0e0e0",
          }}
        >
          <Typography
            mb={0}
            align="center"
            variant="h4"
            color="primary"
            fontSize={mobileSize ? "1.6rem" : "2rem"}
          >
            NOC - Uploaded File
          </Typography>
          <Typography
            mb={0}
            align="center"
            variant="h5"
            color="primary"
            fontSize={mobileSize ? "1.2rem" : "1.5rem"}
          >
            {actionText}
          </Typography>
          <Box
            sx={{
              position: "absolute",
              top: mobileSize ? "-12px" : 0,
              right: mobileSize ? "-12px" : 0,
            }}
          >
            <Tooltip title="Preview Form">
              <IconButton
                onClick={() => {
                  setIsFormPreview(!isFormPreview);
                }}
                color="primary"
                aria-label="preview image"
              >
                <Photo />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        {/* Scrollable Content */}
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            px: mobileSize ? 0 : 2,
            py: 2,
          }}
        >
          {isFormPreview ? (
            <Box sx={{ overflowY: "auto", px: 0, py: 2 }}>
              {currentProcessingFile?.document?.img_urls?.map(
                (image, index) => (
                  <img
                    style={{ width: "100%" }}
                    src={image}
                    alt="Preview"
                    key={index}
                  />
                ),
              )}
            </Box>
          ) : (
            <RenderNocFormFields
              currentProcessingFile={currentProcessingFile}
              setCurrentProcessingFile={setCurrentProcessingFile}
              selectedContractor={selectedContractor}
              setSelectedContractor={setSelectedContractor}
              contractors={contractors}
              setContractors={setContractors}
            />
          )}
        </Box>

        {/* Sticky Footer */}
        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            zIndex: 2,
            bgcolor: "white",
            borderTop: "3px solid #e0e0e0",
            py: 2,
            px: mobileSize ? 0 : 2,
            display: "flex",
            flexDirection: extraSmall ? "column" : "row",
            gap: 2,
            justifyContent: "center",
          }}
        >
          <Button
            onClick={() => {
              setDeleteFormModalOpen(true);
            }}
            color="error"
            startIcon={<DeleteIcon />}
            sx={{ mr: extraSmall ? 0 : "auto" }}
          >
            Create New
          </Button>

          <Button
            disabled={failedValidatedProceed}
            onClick={() => {
              if (cards.length <= 0) {
                dispatch(setModalsState({ addPaymentModalOpen: true }));
              } else {
                dispatch(setModalsState({ paymentModalOpen: true }));
              }
            }}
            endIcon={<FaPlayCircle />}
            size="small"
            color="success"
            variant="contained"
          >
            PROCEED
          </Button>
        </Box>

        <CreateNewNocModal
          open={deleteFormModalOpen}
          onClose={() => {
            if (!deleteFormLoading) {
              setDeleteFormModalOpen(false);
            }
          }}
          onConfirm={handleDeleteDocument}
          deleteFormLoading={deleteFormLoading}
        />
      </Box>
    </>
  );
};

export default NocSelectedPackage;
